export type FileGroup = "Print artwork" | "Packaging" | "Production specs";

export type FileItem = {
  id: string;
  group: FileGroup;
  name: string;
  format: string;
  purpose: string;
};

export const fileGroups: FileGroup[] = ["Print artwork", "Packaging", "Production specs"];

export const manufacturingFiles: FileItem[] = [
  {
    id: "dieline-art",
    group: "Print artwork",
    name: "Face artwork placed on the factory's print template",
    format: "AI or PDF · vector preferred · CMYK · 3 mm bleed · text outlined",
    purpose: "Ask the factory for the template (dieline) for their one print location. Each character's face goes on it at actual size.",
  },
  {
    id: "per-character",
    group: "Print artwork",
    name: "One print file per character",
    format: "AI or PDF · named clearly, e.g. RobotSeries_Frost.pdf",
    purpose: "Each character is a separate print setup, so the factory needs a separate file for each.",
  },
  {
    id: "white-ink",
    group: "Print artwork",
    name: "White-ink layer (for printing on the clear jar)",
    format: "Spot-color layer named \"WHITE\" in the same file",
    purpose: "UV ink on clear plastic looks see-through without a white base under it. Mark where you want it solid.",
  },
  {
    id: "pantone",
    group: "Print artwork",
    name: "Color callout sheet",
    format: "PDF · Pantone C codes for each ink, plus the plastic color",
    purpose: "Screens lie. Pantone codes are how the factory matches color.",
  },
  {
    id: "mockups",
    group: "Print artwork",
    name: "Approved mockups (your renders)",
    format: "PDF or PNG · front and side views per character",
    purpose: "Shows how the art sits on the curve. Your renders work well for this.",
  },
  {
    id: "box",
    group: "Packaging",
    name: "Retail box artwork",
    format: "AI or PDF · 3 mm bleed · on the box maker's dieline",
    purpose: "The quote ships in poly bags. Shops need a hang-tab or countertop box, which is quoted separately.",
  },
  {
    id: "barcode",
    group: "Packaging",
    name: "UPC barcodes, one per character",
    format: "EPS or PDF · 100% black · registered through GS1",
    purpose: "Required by distributors and most store point-of-sale systems.",
  },
  {
    id: "insert",
    group: "Packaging",
    name: "Use and safety insert",
    format: "AI or PDF",
    purpose: "How to use it, a cleaning note, and a line saying to check with a pharmacist before crushing any medication.",
  },
  {
    id: "spec",
    group: "Production specs",
    name: "Product spec sheet",
    format: "PDF · model, plastic color, print location, finish",
    purpose: "The single source of truth the factory quotes and inspects against.",
  },
  {
    id: "po",
    group: "Production specs",
    name: "Purchase order with character breakdown",
    format: "PDF or XLSX · e.g. 1,000 each × 3 characters, sea freight, ship-to address",
    purpose: "Locks price, quantity, and delivery. Nothing starts without it.",
  },
];

export const factoryQuestions: string[] = [
  "Can you send the print template (dieline) for option ① and show exactly where the one print location is?",
  "Can the 3,000 minimum be split across 3 characters, 1,000 each?",
  "What is the minimum order for custom plastic colors (black, sage, neon)?",
  "Can you print full-coverage color over white plastic instead?",
  "Can you print white ink on the clear jar section?",
  "Can we get a printed sample before mass production? Cost and timing?",
  "What does a second print location cost (lid top or clear jar)?",
  "Can you quote a retail box or hang-tab card per unit?",
];

export type ColorwaySpec = {
  id: string;
  name: string;
  swatch: string;
  basePlastic: string;
  print: string;
};

export const colorwaySpecs: ColorwaySpec[] = [
  { id: "frost", name: "Frost", swatch: "#eeeeef", basePlastic: "White (stock)", print: "Black visor, white eye dots, Cool Gray 10 C band" },
  { id: "ember", name: "Ember", swatch: "#1c1d20", basePlastic: "White + full black print, or custom black", print: "Black 6 C coverage, 1375 C eyes, 1495 C band" },
  { id: "moss", name: "Moss", swatch: "#8a9e84", basePlastic: "White + full 5625 C print, or custom sage", print: "5625 C coverage, 802 C eyes, 7488 C band" },
];
